// extracted by mini-css-extract-plugin
export default {"wrapper":"SgZ7hwUNRgJmf05b7Jfj"};